// Estimación de entrega con hora de corte en la zona horaria de la tienda.
// Componente pdp-*: el HTML llega renderizado desde Liquid y este módulo solo añade interacción.

const define = (name, element) => {
  if (!customElements.get(name)) customElements.define(name, element);
};

/* ---------- Estimación de entrega ---------- */
class PdpDelivery extends HTMLElement {
  connectedCallback() {
    this.locale = document.documentElement.lang || 'es';
    this.timeZone = this.dataset.timezone;
    this.holidays = new Set(
      (this.dataset.holidays || '').split(',').map((value) => value.trim()).filter(Boolean)
    );
    try {
      this.render();
    } catch {
      return;
    }
    this.hidden = false;
    this.timer = setInterval(() => document.visibilityState === 'visible' && this.render(), 60000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  // Fecha y hora "de pared" en la zona horaria de la tienda.
  storeNow() {
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat('en-US', {
        timeZone: this.timeZone, hourCycle: 'h23',
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric',
      }).formatToParts(new Date()).map(({ type, value }) => [type, value])
    );
    return new Date(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
  }

  isBusinessDay(date) {
    const day = date.getDay();
    if (this.dataset.skipWeekends === 'true' && (day === 0 || day === 6)) return false;
    const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    return !this.holidays.has(key);
  }

  addBusinessDays(date, days) {
    const result = new Date(date);
    let remaining = days;
    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      if (this.isBusinessDay(result)) remaining -= 1;
    }
    return result;
  }

  render() {
    const now = this.storeNow();
    const cutoffHour = Number(this.dataset.cutoff);
    const shipDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const todayCutoff = new Date(shipDay);
    todayCutoff.setHours(cutoffHour);
    if (!this.isBusinessDay(shipDay) || now >= todayCutoff) {
      do shipDay.setDate(shipDay.getDate() + 1);
      while (!this.isBusinessDay(shipDay));
    }
    const deadline = new Date(shipDay);
    deadline.setHours(cutoffHour);

    const minutesLeft = Math.max(0, Math.floor((deadline - now) / 60000));
    const unit = (value, name) =>
      new Intl.NumberFormat(this.locale, { style: 'unit', unit: name, unitDisplay: 'long' }).format(value);
    const countdown = new Intl.ListFormat(this.locale, { type: 'conjunction' }).format([
      unit(Math.floor(minutesLeft / 60), 'hour'),
      unit(minutesLeft % 60, 'minute'),
    ]);
    const formatDate = new Intl.DateTimeFormat(this.locale, { weekday: 'long', day: 'numeric', month: 'long' });

    const set = (selector, text) => this.querySelectorAll(selector).forEach((element) => (element.textContent = text));
    set('[data-countdown]', countdown);
    set('[data-date-from]', formatDate.format(this.addBusinessDays(shipDay, Number(this.dataset.minDays))));
    set('[data-date-to]', formatDate.format(this.addBusinessDays(shipDay, Number(this.dataset.maxDays))));
  }
}
define('pdp-delivery', PdpDelivery);
